import React from "react";

import useSPTranslation from "../../../reusable/useSPTranslation";

const NEW_APP_URL = "https://app.tutti.net";

type Props = {
  onContinue: () => void;
};

const NewAppPromo: React.FC<Props> = ({ onContinue }) => {
  const { t } = useSPTranslation();

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        maxHeight: "100vh",
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "90vw",
          // Cap the width so image height + text block always fit the viewport (image ratio 1.61:1).
          maxWidth: "min(1280px, calc((100vh - 300px) * 1.61))",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
          backgroundColor: "#ffffff",
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/img/tutti-space.svg`}
          alt={t("components.login.newApp.imageAlt")}
          style={{
            width: "100%",
            display: "block",
          }}
        />
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "30px 25px 25px",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: "480px", margin: "0 auto" }}>
            <h3 style={{ marginTop: 0 }}>
              {t("components.login.newApp.title")}
            </h3>
            <p style={{ marginBottom: "20px" }}>
              {t("components.login.newApp.description")}
            </p>
            <a
              className="btn btn-primary btn-block"
              href={NEW_APP_URL}
              rel="noopener noreferrer"
              style={{
                backgroundColor: "#1B323B",
                border: 0,
                borderRadius: 12,
                padding: 12,
                fontSize: 18,
              }}
            >
              {t("components.login.newApp.button")}
            </a>
            <div
              className="btn btn-blank"
              style={{ marginTop: "10px", width: "100%" }}
              onClick={onContinue}
            >
              {t("components.login.newApp.continue")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewAppPromo;
